<template>
  <el-dialog
    :visible.sync="visible"
    :title="'物料清单设置 - '+$productName(product)"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="90%"
  >
    <el-form
      :model="dataForm"
      :rules="dataRule"
      ref="dataForm"
      label-width="120px"
    >
      <div class="w-full flex justify-end mb-4">
        <div class="template-box">
          <el-select v-model="bomTemplateId"  placeholder="请选择单耗模板" @change="selBomTemplate" size="mini" style="margin-right: 10px;">
            <el-option
                v-for="item in bomTemplateList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </div>
        <el-button
          size="mini"
          icon="el-icon-plus"
          @click="addRow()"
          type="primary"
          >增加原料</el-button
        >
      </div>
      <SweetTable :data="dataForm.detailList" :is-page="false" :height="400">
        <el-table-column label="物料名称" align="center">
          <template slot-scope="scope">
            <el-form-item
              :prop="'detailList.' + scope.$index + '.name'"
              :rules="dataRule.name"
              label-width="0"
              style="margin-top: 20px"
            >
              <el-input v-model="scope.row.name" placeholder="物料名称" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
          label="物料颜色"
          prop="color"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-form-item
              :prop="'detailList.' + scope.$index + '.color'"
              label-width="0"
              style="margin-top: 20px"
            >
              <el-input v-model="scope.row.color" placeholder="物料颜色" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
          label="物料规格"
          prop="size"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-form-item
              :prop="'detailList.' + scope.$index + '.size'"
              label-width="0"
              style="margin-top: 20px"
            >
              <el-input v-model="scope.row.size" placeholder="物料规格" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="物料幅宽" header-align="center" align="center">
          <template slot-scope="scope">
            <el-form-item
              :prop="'detailList.' + scope.$index + '.attr1'"
              label-width="0"
              style="margin-top: 20px"
            >
              <el-input v-model="scope.row.attr1" placeholder="物料幅宽" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="物料克重" header-align="center" align="center">
          <template slot-scope="scope">
            <el-form-item
              :prop="'detailList.' + scope.$index + '.attr2'"
              label-width="0"
              style="margin-top: 20px"
            >
              <el-input v-model="scope.row.attr2" placeholder="物料克重" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
          label="单耗"
          header-align="center"
          align="center"
          width="120"
        >
          <template slot-scope="scope">
            <el-form-item
              :prop="'detailList.' + scope.$index + '.count'"
              :rules="dataRule.count"
              label-width="0"
              style="margin-top: 20px"
            >
              <el-input v-model="scope.row.count" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          width="100"
          label="操作"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              icon="el-icon-remove"
              size="mini"
              @click="delRow(scope.$index, scope.row, 'detailList')"
            >
              移除
            </el-button>
          </template>
        </el-table-column>
      </SweetTable>
    </el-form>
    <template slot="footer">
      <el-button @click="cancel()" size="mini">{{ $t("cancel") }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()"  size="mini">{{
        $t("confirm")
      }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from "lodash/debounce";
import { isNumber, moneyValidator } from '@/utils/validate'

export default {
  mixins: [],
  data() {
    return {
      visible: false,
      orderDetailId: "",//订单明细id
      product:{},//订单品番信息
      dataForm: {
        detailList: [],
      },
      bomTemplateList: [],
      bomTemplateId:''
    };
  },
  computed: {
    dataRule() {
      return {
        name: [{ required: true, message: "请填写名称", trigger: "change" }],
        code: [{ required: true, message: "请填写品番号", trigger: "change" }],
        count: [
          { required: true, message: "请填写数量", trigger: "change" },
          {
            validator: function (rule, value, callback) {
              if(!isNumber(value)){
                callback(new Error('请输入正确的数量'))
                return
              }
              callback()
            },
            trigger: 'change',
          }
        ],
      };
    },
  },
  methods: {
    selBomTemplate(e) {
      if (!e) {
        return;
      }
      let bomTemplate=this.bomTemplateList.find(item=>item.id===e)
      if(!bomTemplate||!bomTemplate.detailList){
        return
      }
      let detailList = JSON.parse(bomTemplate.detailList);
      if (!detailList || detailList.length === 0) {
        return;
      }
      detailList.forEach((b) => {
        if(!b.count){
          b.count = "";
        }
      });
      this.dataForm.detailList = detailList;
    },
    getBomTemplateList() {
      this.$http.get(`/trade/bom/template/list`).then(({ data: res }) => {
        this.bomTemplateList = res.data;
        console.log("this.bomTemplateList", this.bomTemplateList);
      });
    },
    async getBomList() {
      if (!this.orderDetailId) {
        return;
      }
      const { data: res } = await this.$http.get(`/trade/bom/list`, {
        params: { agreementDetailId: this.orderDetailId },
      });
      if (res.data) {
        this.dataForm.detailList = res.data;
      }
    },
    cancel() {
      this.visible = false;
    },
    delRow(index, row, dataKey) {
      if (this.dataForm[dataKey]) {
        this.dataForm[dataKey].splice(index, 1);
      }
    },
    getNewRow() {
      return {
        name: "",
        code: "",
        color: "",
        size: "",
        attr1: "",
        attr2: "",
        count: ""
      };
    },
    addRow(dataKey) {
      if (!dataKey) {
        dataKey = "detailList";
      }
      this.dataForm[dataKey].push(this.getNewRow());
    },
    async reset() {
      this.dataForm.detailList = [];
      await this.getBomList();
      if (this.$refs["dataForm"]) {
        this.$refs["dataForm"].clearValidate();
      }
    },
    init() {
      this.getBomTemplateList();
      this.reset();
      this.visible = true;
    },
    checkUnique() {
      let r = true;
      if (!this.dataForm.detailList || this.dataForm.detailList.length === 0) {
        return r;
      }

      for (let i = 0; i < this.dataForm.detailList.length; i++) {
        let item = this.dataForm.detailList[i];
        for (let j = 0; j < this.dataForm.detailList.length; j++) {
          let item2 = this.dataForm.detailList[j];
          if (i === j) {
            continue;
          }
          let pk =
            item.code === item2.code &&
            item.name === item2.name &&
            item.color === item2.color &&
            item.size === item2.size &&
            item.attr1 === item2.attr1 &&
            item.attr2 === item2.attr2;
          if (pk) {
            console.log(item,item2)
            return !pk;
          }
        }
      }
      return r
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function() {
      this.$refs["dataForm"].validate(
        (valid) => {
          if (!valid) {
            return false;
          }
          if (!this.checkUnique()) {
            return this.$message.error("存在重复原辅料,请检查");
          }
          let postForm = this.$clone(this.dataForm.detailList);
          if (this.orderDetailId) {
            postForm.forEach((item) => {
              item.agreementDetailId = this.orderDetailId;
            });
          }
          this.$emit("change", postForm);
          this.visible = false;
        },
        1000,
        { leading: true, trailing: false }
      );
    }),
  },
};
</script>

<style lang="scss" scoped>
.template-box {
  display: flex;
  padding: 0 20px;
  flex-wrap: wrap;
  padding-right: 0;
  .item {
    margin-right: 20px;
    cursor: pointer;
  }
}
</style>
